export const jobSummary = {
  position: {
    badges: 'Badges',
    skillsAndRequirements: 'Skills & Requirements',
    tasks: 'Tasks',
    pay: {
      hourly: '%hourlyRate% Hourly',
      flat: '%flatRate% Flat'
    }
  },
  schedule: {
    dateInputLabel: 'Select dates',
    totalWorkdays: 'TOTAL WORKDAYS',
    daysVary: 'Days vary',
    viewInCalendar: 'View in calendar',
    timeRange: '%startTime% - %endTime%',
    dayTimeRange: '%day% is %startTime% - %endTime%',
    customizedTimeRange: '%date% is %startTime% - %endTime%',
    rest: 'Rest',
    unpaidBreakMinutes: '%unpaidBreakMinutes% min break',
    calendar: {
      header: 'Job Schedule',
      close: 'Got it'
    }
  }
};
